import { Box } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import InputSelect from 'UiKit/input-select';
import { TextBold } from 'UiKit/typography';
import useGetRescheduleHosts from 'Domain/reschedule/useGetRescheduleHosts';

import styles from './styles.module.css';

const ChangeHost = ({ form }) => {
  const { t } = useTranslation('host-reschedule');
  const { setValue, watch } = form;
  const { id } = useParams();

  const { data: hostOptions } = useGetRescheduleHosts(id);

  const { hostChangeHost } = watch();

  return (
    <Box className={styles['change-host__container']}>
      <TextBold className={styles['change-host__title-step-text']}>
        {t('form_change_host.section_title')} <span>*</span>
      </TextBold>
      <Box className={styles['change-host__form--field']}>
        <InputSelect
          placeholder={t('form_change_host.replacement_host_placeholder')}
          onChange={(e) => setValue('hostChangeHost', e)}
          options={hostOptions}
          value={hostChangeHost}
          label={t('form_change_host.replacement_host')}
          isRequired={true}
        />
      </Box>
    </Box>
  );
};

export default ChangeHost;
